/* eslint-disable import-x/prefer-default-export */
import { createRoutine } from 'redux-saga-routines';
import { UNSUSCRIBE_EMAIL } from './types';

export const unsuscribeEmail = createRoutine(UNSUSCRIBE_EMAIL);
